<button
  mat-icon-button
  onclick="this.blur()"
  (click)="openSettingsPopup()"
  [matTooltip]="T_SCOPE + '.buttons.settings-popup' | translate | lowercase"
>
  <wlm-icon class="wtr-icon-xxs-size" [icon]="'settings'"></wlm-icon>
</button>
